<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><br/><br/></p>
<p class="nonindent" id="col1">The story which follows was inspired by an event which took place in our country not many years ago. However, it is a work of fiction and any resemblance to living persons or actual places is accidental.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317392_epub_col1_r1.vue?3ac51d29